import { groupColumns } from '../../../../../backend/features/groups/shared';
import { requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { onAuthGet, onAuthImport, onAuthList, onAuthPost } from './Callbacks/OnAuth';
import { onChangeSync } from './Callbacks/OnChangeSync';
import { onImportRow } from './Callbacks/OnImport';
import { onMigrate } from './Callbacks/OnMigrate';
import { onTransform } from './Callbacks/OnTransform';
export const groupEntity = {
    version: 6,
    columns: groupColumns,
    onAuthGet: onAuthGet,
    onAuthList: onAuthList,
    onAuthPost: onAuthPost,
    onMigrate: onMigrate,
    onTransform: onTransform,
    onChangeSync: onChangeSync,
    onAuthImport: onAuthImport,
    onImportRow: onImportRow,
    onAuthMassDelete: (_appState, userState) => {
        if (!requireAnySystemPermission(userState, 'manage-groups')) {
            throw new Error('Unauthorized');
        }
    },
};
